import React from "react"
import { Box, Flex } from "@rebass/grid/emotion"
import styled from "@emotion/styled"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import BulletIcon from "../../../../../assets/icons/nova/bullet-orange.svg"

const GwpModalContentWrapper = styled.div`
  svg {
    width: 4px;
    height: 4px;
  }
`

const GwpModalContent = ({ data }) => {
  const { headline, items, image, terms } = data
  return (
    <GwpModalContentWrapper>
      <Flex
        flexDirection={["column", null, null, "row"]}
        className="md:gap-5 lg:gap-10 md:py-10"
        alignItems={[null, null, null, "center"]}
      >
        <Box className="rounded md:max-w-[390px]">
          <img src={image} alt={``} role="presentation" className="w-full" />
        </Box>

        <Box pt={[16, null, null, 0]}>
          <TextElementNova
            element="h3"
            text={headline}
            className="Title-10-Super-Normal pb-4 md:pb-8 text-center md:text-left"
          />

          <Flex flexDirection={"column"} className="gap-2">
            {items.map((item, index) => {
              return (
                <Flex
                  key={`benefit-${index}`}
                  alignItems={"center"}
                  className="gap-2"
                >
                  <BulletIcon />

                  <TextElementNova text={item} className="Body-10-Dia-Normal" />
                </Flex>
              )
            })}
          </Flex>
        </Box>
      </Flex>

      <TextElementNova
        element="p"
        text={terms}
        className="Caption-10-Dia-Normal text-nova-transparency-black-60 pt-4 sm:pt-10 text-center"
      />
    </GwpModalContentWrapper>
  )
}

export default GwpModalContent
